import { render, staticRenderFns } from "./accountBinding.vue?vue&type=template&id=77cba23f&scoped=true"
import script from "./accountBinding.vue?vue&type=script&lang=js"
export * from "./accountBinding.vue?vue&type=script&lang=js"
import style0 from "./accountBinding.vue?vue&type=style&index=0&id=77cba23f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cba23f",
  null
  
)

export default component.exports